// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__KECkF","requiredAsterisk":"Info_requiredAsterisk__cnyxx"};